// extracted by mini-css-extract-plugin
module.exports = {"tableActions":"TableActions_tableActions__2xWol"};